import * as sonbpIfconst from "../../sonbpIf/base/constants";
import { Logger } from "../../util/logger";
import { GetEditInfo, util } from "../..";
import { constDialogMessage, dialogUtil } from "../../util";

import * as edconst from "../edit.const";
import { EditConst } from "../edit.const";
import { itemVenderProperty } from "../edit.sonbp_if";
import { BaseStampLogicClass } from "./edit.baseStampLogic";


/**
 * マスタスタンプ
 * 
 * マスタスタンプのエンティティはアップロードスタンプとは構造が違うため、共通化できず。。
 * 画面制御の一部処理を共有化のためにクラス化しています。
 */
export class MstStampLogicClass extends BaseStampLogicClass {

// #region ■定数

    protected readonly VIEW_TITLE: string = EditConst.TITLE_STAMP;
    protected readonly VIEW_MODE: string = edconst.EDIT_MODE_KIND.STAMP;
    protected readonly VIEW_ITEM_TYPE: string = sonbpIfconst.ITYPE_STAMP_IMG;

    /**
     * 配置上限数
     * @override
     */
    protected readonly PUT_MAX: number = 50;

// #endregion

// #region ■イベント

    /**
     * ツールメニュー：スタンプ押下メソッド
     * @summary 編集モードをスタンプにして画面表示を切り替える。
     * @param selectedItemVp 選択済みアイテム（2025年対応：配置済み画像の再編集可能 #28295）
     * @implements
     */
    public btnClickStampMenu(event: JQueryEventObject, selectedItemVp: itemVenderProperty = null): void {

        if (this._edctrl.editMode === edconst.EDIT_MODE_KIND.STAMP) {
            return;
        }

        // sonbpへ処理モード変更依頼
        this.sonbpIfController.setMode(edconst.EDIT_MODE_KIND.STAMP,
            () => {
                // 正常終了の場合
                this._edctrl.editMode = edconst.EDIT_MODE_KIND.STAMP;

                this.setShowFlgAllOFF();

                if (this._usePcDesign) {
                    // PC用
                    // パネルの表示制御
                    this._vue.$data.Show.OparatePallet = true;
                    this._vue.$data.Show.StampPanel = true;

                    // ツールメニューの活性制御
                    this._vue.$data.ActiveStampMenu = true;

                    // フェードインアウトの初期化
                    this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_OUT;
                    this._vue.$data.Stamp.fade.In = false;
                    this._vue.$data.Stamp.fade.Out = false;

                    // オブジェクト操作パレットの制御
                    this._edctrl.setModeOparatePallet(edconst.EDIT_MODE_KIND.STAMP, null);

                    // 選択アイテムの指定
                    this.sonbpIfController.getMstStampList(
                        (list: itemVenderProperty[]) => {
                            if (0 < list.length) {
                                this._vue.$data.Show.OparatePalletCover = false;

                                const idx = selectedItemVp?.idx ?? list[0].idx;
                                this.sonbpIfController.selectItem(sonbpIfconst.ITYPE_STAMP_IMG, idx,
                                    () => {
                                        Logger.debug("選択アイテムの指定 成功");
                                    },
                                    () => {
                                        Logger.error("選択アイテムの指定 失敗");
                                        this._vue.$data.Show.OparatePalletCover = true;
                                    });
                            }
                            else {
                                this._vue.$data.Show.OparatePalletCover = true;
                            }
                        }
                    );
                }
                else {
                    // SP用
                    // ヘッダーメニュー

                    // パネルの表示制御
                    this._vue.$data.Show.EditArea = true;
                    this._vue.$data.Show.FooterMenu = true;

                    // 履歴処理開始
                    this.sonbpIfController.historyStart();

                    this.sonbpIfController.getMstStampList((list: itemVenderProperty[]) => {
                        // 作成済みのスタンプが存在するか判定
                        if (0 < list.length) {
                            // 存在する場合、スタンプの位置調整表示
                            this._vue.$data.Header.Title = EditConst.TITLE_STAMP;
                            this._vue.$data.Show.ReturnHomeExBtn = true;
                            this._vue.$data.Show.StampDeleteBtn = true;
                            this._vue.$data.Show.CommitNextHomeBtn = true;
                            this._vue.$data.Stamp.DelBtnEnable = false;

                            // オブジェクト操作パレットの表示制御
                            this._vue.$data.Show.OparatePallet = true;
                            this._edctrl.setModeOparatePallet(edconst.EDIT_MODE_KIND.STAMP, null);

                            // タッチイベント制御(無効)
                            this._edctrl.touchEventChange(false);

                            this._vue.$data.Show.OparatePalletCover = false;

                            // 選択アイテムの指定
                            const idx = selectedItemVp?.idx ?? list[0].idx;
                            this.sonbpIfController.selectItem(sonbpIfconst.ITYPE_STAMP_IMG, idx,
                                () => {
                                    Logger.debug("選択アイテムの指定 成功");
                                    this._vue.$data.Stamp.DelBtnEnable = true;
                                },
                                () => {
                                    Logger.error("選択アイテムの指定 失敗");
                                    this._vue.$data.Show.OparatePalletCover = true;
                                });
                        }
                        else {
                            // 存在しない場合、スタンプの編集表示
                            this.setStampEditMode();
                        }
                    });
                }

            },
            () => {
                // 異常終了の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CHANGE_MODE, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
            });
    }

    /**
    * スタンプパネル スタンプ画像押下
    * @param event
    */
    public imgClickStamp(event: JQueryEventObject, stampId: number): void {

        Logger.debug("スタンプ画像押下メソッド stampId[" + stampId + "]");

        // 上限チェック
        let count = this.UseCount();
        if (count >= this.PUT_MAX) {
            dialogUtil.createErrorDialog(`配置可能な上限(${this.PUT_MAX}件)を超えました。`, dialogUtil.closeErrorDialog);
            return;
        }

        let that = this;

        // ローディングダイアログ開始
        util.dialogUtil.showLoading();

        // 対象スタンプ情報取得
        const target: GetEditInfo.GetEditInfoStampCategoryEntity = util.relic.listFind(this._edctrl.editInfo.master.stamp, (stamp: GetEditInfo.GetEditInfoStampCategoryEntity) => {
            return stamp.id === stampId;
        });

        // スタンプの一覧を取得
        this.sonbpIfController.getMstStampList((stampList: itemVenderProperty[]) => {

            // アイテム番号の採番
            let idx: number;
            if (stampList.length === 0) {
                idx = 1;
            }
            else {
                let idxTmp: number = -1;
                for (let i: number = 0; i < stampList.length; i++) {
                    const idx: number = Number(stampList[i].idx);
                    if (idxTmp < idx) {
                        idxTmp = idx;
                    }
                }
                idx = idxTmp + 1;
            }

            // sonbpへ依頼
            this.sonbpIfController.setStamp(idx, target,
                () => {
                    // 正常終了の場合
                    if (!this._usePcDesign) {
                        // SP用
                        that.returnStampHomeBtn(null);
                    }
                    util.dialogUtil.closeLoading();
                },
                () => {
                    // 上記以外の場合
                    util.dialogUtil.closeLoading();
                    util.dialogUtil.createErrorDialog(
                        constDialogMessage.ERROR_EDIT_CREATE_STAMP,
                        () => {
                            util.dialogUtil.closeErrorDialog();
                        }
                    );
                });
        });
    }


    // #region ■イベント（SPのみ処理）

    /**
     * スタンプ追加ボタン押下(SP用)
     * @param event
     */
    public btnClickStampSet(event: JQueryEventObject): void {

        Logger.debug("スタンプ追加ボタン押下(SP用)");

        this.imgClickStamp(event, this._vue.$data.Stamp.TargetStamp);
    }

    /**
     * スタンプのカテゴリコンボ押下(SP用)
     * @param event
     */
    public cmbClickStampCategory(event: JQueryEventObject): void {

        Logger.debug("スタンプのカテゴリコンボ押下(SP用)");

        this._vue.$data.Show.StampCategoryList = true;
        this._vue.$data.Show.DialogArea = true;

    }

    /**
     * スタンプのカテゴリイメージ押下(SP用)
     * @param event
     */
    public imgClickStampCategory(event: JQueryEventObject): void {

        Logger.debug("スタンプのカテゴリイメージ押下(SP用)");

        this._vue.$data.Stamp.TargetStamp = "";
        this._vue.$data.Show.DialogArea = false;
        this._vue.$data.Show.StampCategoryList = false;

    }

    /**
     * スタンプパネル スタンプ画像押下(SP用)
     * @param event
     */
    public imgClickStampForSp(event: JQueryEventObject, stampId: number): void {

        Logger.debug("スタンプパネル スタンプ画像押下(SP用) stampId[" + stampId + "]");

        this._vue.$data.Stamp.TargetStamp = stampId;
    }

    // #endregion

// #endregion

// #region ■内部関数

    /**
     * スタンプ編集モードへ画面項目設定(SP用)
     * @summary スタンプ一覧画面を表示する。
     * @implements
     */
    public setStampEditMode() {

        // パネルの表示制御
        this.setShowFlgAllOFF();
        this._vue.$data.Header.Title = EditConst.TITLE_STAMP_EDIT;
        this._vue.$data.Stamp.TargetStamp = "";
        this._vue.$data.Show.ReturnStampHomeBtn = true;
        this._vue.$data.Show.StampPanel = true;
    }

// #endregion

}
